import { render, staticRenderFns } from "./LivePricesCard.vue?vue&type=template&id=0bfc89fc"
import script from "./LivePricesCard.vue?vue&type=script&lang=js"
export * from "./LivePricesCard.vue?vue&type=script&lang=js"
import style0 from "./LivePricesCard.vue?vue&type=style&index=0&id=0bfc89fc&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bfc89fc')) {
      api.createRecord('0bfc89fc', component.options)
    } else {
      api.reload('0bfc89fc', component.options)
    }
    module.hot.accept("./LivePricesCard.vue?vue&type=template&id=0bfc89fc", function () {
      api.rerender('0bfc89fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PriceWatcher/LivePricesCard.vue"
export default component.exports